export default class GoalListModel {
  constructor() {
    this.isGoalListLoaded = false;
    this.totalValue = 0;
    this.totalCash = 0;
    this.goalList = [];
  }
}
